<template>
  <div id="app" class="container">

    <h1>Say Goodbye To <img src="./assets/ie.png" alt="IE" class="ie"></h1>

    <div class="row">
      <div class="alert alert-success" v-if="isGoodBrowser">
        <font-awesome-icon icon="check"/>
        You're using <b>{{ browser }}</b>.
        Great Job!
      </div>
      <div class="alert alert-danger" v-else>
        <font-awesome-icon icon="times"/>
        Oh no! You're using the browser <b>which must not be named</b>.
        Here are some magical alternatives:
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 col-sm-6 alert" :class="{ 'alert-info': browser.current }"
           v-for="browser in goodBrowsers" :key="browser.name">
        <img :src="browser.logo" :alt="`${browser.name} Logo`" class="logo">
        <br><br>
        <a :href="browser.link" class="btn btn-primary">
          <font-awesome-icon icon="download"/>
          {{ browser.name }}
        </a>
      </div>
    </div>

    <hr>

    <footer class="text-muted">
      <p>
        All trademarks &amp; logos are the property of their respective owners. All rights reserved.
      </p>
      <p>
        Made with <font-awesome-icon icon="heart" style="color: #d32f2f"/> by
        <a href="https://clevyr.com">
          <img src="./assets/clevyr.svg" alt="Clevyr" class="svg-inline--fa"></a>.
        &copy; {{ year }}.
      </p>
    </footer>
  </div>
</template>

<script>
import chromeLogo from './assets/chrome.svg';
import firefoxLogo from './assets/firefox.svg';
import edgeLogo from './assets/edge.svg';
import safariLogo from './assets/safari.svg';

export default {
  name: 'App',

  computed: {
    browser() {
      switch (this.$browserDetect.meta.name) {
        case 'MSIE':
          return 'Internet Explorer';
        default:
          return this.$browserDetect.meta.name;
      }
    },
    isGoodBrowser() {
      return !this.$browserDetect.isIE;
    },
    goodBrowsers() {
      return [
        {
          name: 'Google Chrome',
          link: 'https://google.com/chrome/',
          logo: chromeLogo,
          current: this.$browserDetect.isChrome,
        },
        {
          name: 'Mozilla Firefox',
          link: 'https://www.mozilla.org/en-US/firefox/browsers/',
          logo: firefoxLogo,
          current: this.$browserDetect.isFirefox,
        },
        {
          name: 'Microsoft Edge',
          link: 'https://www.microsoft.com/en-us/edge',
          logo: edgeLogo,
          current: this.$browserDetect.isEdge,
        },
        {
          name: 'Safari',
          link: 'https://www.apple.com/safari/',
          logo: safariLogo,
          current: this.$browserDetect.isSafari,
        },
      ];
    },
    year() {
      return (new Date()).getFullYear();
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Lobster&display=swap");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
  font-size: 1.25em;

  h1 {
    font-family: Lobster, cursive;
    font-size: 4em;
  }

  .ie {
    height: 2em;
    vertical-align: middle;
  }

  .logo {
    object-fit: contain;
    height: 160px;
    width: 160px;
  }

  .btn {
    font-size: 1em;
  }

  footer {
    font-size: 0.8em;
  }
}
</style>
